import CryptoJS from 'crypto-js'

const SECRET =
  process.env.NEXT_PUBLIC_ENCRYPT_SECRET || 'default_secret Hereee eeee'

export function encryptData (data) {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET
  ).toString()
  return ciphertext
}

export function decryptData (ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext.replace(/\s+/g, '+'), SECRET)
  const decrypted = bytes.toString(CryptoJS.enc.Utf8)
  return JSON.parse(decrypted)
}
